import LeaderPage from './LeaderPage';

export default LeaderPage;
